import ApiServiceBase from "@/services/api/apiServiceBase";

type SettingsCatalog = Record<string, any> | null;

let cachedSettings: SettingsCatalog = null;

export class SettingsService extends ApiServiceBase {

    public async get(force = false): Promise<any> {
        if (cachedSettings && !force) return cachedSettings;
        // Prefer authenticated catalogs so mature options load when opted in
        try {
            cachedSettings = await this.http?.get('/settings');
        } catch {
            cachedSettings = await this.http?.get('/settings', {}, false);
        }
        return cachedSettings;
    }

    public async appSettings(): Promise<any> {
        try {
            return await this.http?.get('/settings/app-settings');
        } catch {
            return this.http?.get('/settings/app-settings', {}, false);
        }
    }

    private async catalogKey(key: string): Promise<any[]> {
        const settings = await this.get();
        const value = settings?.[key];
        return Array.isArray(value) ? value : [];
    }

    public async getGenders(): Promise<any> {
        return this.catalogKey('genders');
    }

    public async getSexualities(): Promise<any> {
        return this.catalogKey('sexualities');
    }

    public async getDesires(): Promise<any> {
        return this.catalogKey('desires');
    }

    public async getPronouns(): Promise<any> {
        return this.catalogKey('pronouns');
    }

    public async getBodyTypes(): Promise<any> {
        return this.catalogKey('bodyTypes');
    }

    public async getSmokingTypes(): Promise<any> {
        return this.catalogKey('smokingType');
    }

    public async getDrinkingTypes(): Promise<any> {
        return this.catalogKey('drinkingTypes');
    }

    public async getReligions(): Promise<any> {
        return this.catalogKey('religions');
    }

    public async getHashtags(): Promise<any> {
        return this.catalogKey('hashtags');
    }

    /** Aliases matching catalog keys from GET /settings */
    public async genders(): Promise<any> {
        return this.getGenders();
    }

    public async sexualities(): Promise<any> {
        return this.getSexualities();
    }

    public async desires(): Promise<any> {
        return this.getDesires();
    }

    public async pronouns(): Promise<any> {
        return this.getPronouns();
    }

    public async bodyTypes(): Promise<any> {
        return this.getBodyTypes();
    }

    public async smokingType(): Promise<any> {
        return this.getSmokingTypes();
    }

    public async drinkingTypes(): Promise<any> {
        return this.getDrinkingTypes();
    }

    public async religions(): Promise<any> {
        return this.getReligions();
    }

    public async hashtags(): Promise<any> {
        return this.getHashtags();
    }

    public clearCache(): void {
        cachedSettings = null;
    }
}
